import { ChangeEvent } from "react";
import { Box, MenuItem } from "@mui/material";
import { AppTextField } from "src/Pages/components";
import { ModalFilterCore } from "src/Pages/components/ModalFilterCore/Index";

import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useHttpTableLeads } from "../table/Hooks/useHttpTableLeads";
import { useContextLeads } from "src/Contexts/Leads/LeadsContext";
import { valuesDefaultFilterLeads } from "src/Contexts/Leads/valuesDefaultInputsLeads/ValueDefaultInputLeads";
import { IValuesFilterLeads } from "src/Contexts/Leads/LeadsTypes";

export const FilterSidebar = () => {
  const { setValuesFilterLeads, valuesFilterLeads } = useContextLeads();

  const { setAttTable } = useConfigPageContext();

  const { handleGet } = useHttpTableLeads();

  const handleChange =
    (prop: keyof IValuesFilterLeads) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesFilterLeads({
        ...valuesFilterLeads,
        [prop]: event.target.value,
      });
    };

  const ClearFilter = async () => {
    setAttTable((item) => !item);
    setValuesFilterLeads(valuesDefaultFilterLeads);
  };

  const FilterSearch = async () => {
    await handleGet();
  };

  return (
    <ModalFilterCore FilterClear={ClearFilter} FilterSearch={FilterSearch}>
      <Box
        id="container leads"
        sx={{
          "& > .MuiAutocomplete-root, & > .MuiTextField-root": {
            flexWrap: "wrap",
            display: "flex",
            marginBottom: "1rem",
          },
        }}
      >
        <AppTextField
          label="Nome"
          fullWidth
          value={valuesFilterLeads.name}
          onChange={handleChange("name")}
        />
        <AppTextField
          label="Nível de interesse"
          fullWidth
          select
          value={valuesFilterLeads.interestLevel}
          onChange={handleChange("interestLevel")}
        >
          <MenuItem value=" ">Todos</MenuItem>
          <MenuItem value="HIGH">Alto</MenuItem>
          <MenuItem value="MEDIUM">Médio</MenuItem>
          <MenuItem value="LOW">Baixo</MenuItem>
        </AppTextField>
        <AppTextField
          label="Status"
          fullWidth
          select
          value={valuesFilterLeads.status}
          onChange={handleChange("status")}
        >
          <MenuItem value=" ">Todos</MenuItem>
          <MenuItem value="NEW">Novo</MenuItem>
          <MenuItem value="IN_CONTACT">Em contato</MenuItem>
          <MenuItem value="PROPOSAL_SENT">Proposta enviada</MenuItem>
          <MenuItem value="PROGRESS">Em andamento</MenuItem>
          <MenuItem value="FUTURE_RECONTACT">Futuro contato</MenuItem>
          <MenuItem value="DISQUALIFIED">Desqualificado</MenuItem>
          <MenuItem value="LOST">Perdido</MenuItem>
        </AppTextField>
        <AppTextField
          label="Fonte"
          fullWidth
          select
          value={valuesFilterLeads.sourceCollection}
          onChange={handleChange("sourceCollection")}
        >
          <MenuItem value=" ">Todos</MenuItem>
          <MenuItem value="INDICATION">Indicação</MenuItem>
          <MenuItem value="GOOGLE">Google</MenuItem>
          <MenuItem value="FORM">Formulários</MenuItem>
          <MenuItem value="LADING_PAGE">Landing Page</MenuItem>

          <MenuItem value="FACEBOOK">FaceBook</MenuItem>
          <MenuItem value="INSTAGRAM">Instagram </MenuItem>
          <MenuItem value="LINKEDIN">LinkeDIn</MenuItem>

          <MenuItem value="EMAIL_MARKETING">Email</MenuItem>
          <MenuItem value="MARKETING">Marketing</MenuItem>
          <MenuItem value="DUTY">Plantão</MenuItem>
          <MenuItem value="STREET">Rua</MenuItem>
          <MenuItem value="LISTING">Listagem</MenuItem>
        </AppTextField>
      </Box>

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
          alignItems: "center",
        }}
      >
        <AppTextField
          label="Data de criação"
          type="date"
          value={valuesFilterLeads.startDateExpiration}
          onChange={handleChange("startDateExpiration")}
        />
        até
        <AppTextField
          label="Data de criação"
          type="date"
          value={valuesFilterLeads.endDateExpiration}
          onChange={handleChange("endDateExpiration")}
        />
      </Box> */}
    </ModalFilterCore>
  );
};
